export default __webpack_public_path__ + "static/Cloning_Chamber-7e4f135bd921384406a9b90e179fac9e.png";